import request from "@/utils/request";

export function getDynamicVariables(data) {
  return request({
    url: "/dynamic_variables",
    method: "post",
    data,
  });
}
export function createDynamicVariables(data) {
  return request({
    url: "/dynamic_variables/create",
    method: "post",
    data,
  });
}
export function updateDynamicVariables(data) {
  return request({
    url: "/dynamic_variables/update",
    method: "post",
    data,
  });
}
export function deleteDynamicVariables(data) {
  return request({
    url: "/dynamic_variables/delete",
    method: "delete",
    data,
  });
}

export function getSequenceList(data, signal) {
  return request({
    url: "/sequences",
    method: "post",
    data,
    signal,
  });
}
export function lookupSequence(data, options = {}) {
  return request({
    url: "/sequences/lookup",
    method: "post",
    data,
    ...options,
  });
}
export function archiveSequences(data) {
  return request({
    url: "/sequences/archive",
    method: "post",
    data,
  });
}

export function createSequences(data, options = {}) {
  return request({
    url: "/sequences/create",
    method: "post",
    data,
    options,
  });
}

export function generateSequence(data, options = {}) {
  return request({
    url: "/sequences/generate",
    method: "post",
    data,
    ...options,
  });
}

export function enhanceSequence(data, options = {}) {
  return request({
    url: "/sequences/enhance",
    method: "post",
    data,
    ...options,
  });
}

export function deleteSequences(data, options = {}) {
  return request({
    url: "/sequences/delete",
    method: "delete",
    data,
    options,
  });
}
export function updateSequences(data, signal) {
  return request({
    url: "/sequences/update",
    method: "post",
    data,
    signal,
  });
}
export function activeSequences(data, signal) {
  return request({
    url: "/sequences/activate",
    method: "post",
    data,
    signal,
  });
}
export function inactiveSequences(data) {
  return request({
    url: "/sequences/deactivate",
    method: "post",
    data,
  });
}

/*-----------------labels--------------------*/
export function querySequenceLabelListAPI(data, signal) {
  return request({
    url: "/sequences/tags",
    method: "post",
    data,
    signal,
  });
}

export function createSequenceLabelAPI(data, options = {}) {
  return request({
    url: "/sequences/tags/create",
    method: "post",
    data,
    options,
  });
}

export function addLabelsToSequenceAPI(data, options = {}) {
  return request({
    url: "/sequences/tags/add",
    method: "post",
    data,
    options,
  });
}
export function removeLabelsFromSequenceAPI(data, options = {}) {
  return request({
    url: "/sequences/tags/remove",
    method: "post",
    data,
    options,
  });
}

export function updateSequenceLabelAPI(data, options = {}) {
  return request({
    url: "/sequences/tags/update",
    method: "post",
    data,
    options,
  });
}

export function deleteSequenceLabelAPI(data, options = {}) {
  return request({
    url: "/sequences/tags/delete",
    method: "delete",
    data,
    options,
  });
}

/** ------------- templates start -------------- */
export function getTemplateChannelsAPI(options = {}) {
  return request({
    url: "/channels/types/templates",
    method: "get",
    options,
  });
}

export function getTemplateListAPI(data, options = {}) {
  return request({
    url: "/channels/templates",
    method: "post",
    data,
    options,
  });
}

export function getTemplateFullListAPI(data, options = {}) {
  return request({
    url: "/channels/templates/full",
    method: "post",
    data,
    ...options,
  });
}

export function createTemplateAPI(data, options = {}) {
  return request({
    url: "/channels/templates/create",
    method: "post",
    data,
    ...options,
  });
}

export function createTemplateVersionAPI(data, options = {}) {
  return request({
    url: "/channels/templates/create_version",
    method: "post",
    data,
    ...options,
  });
}

export function setDefaultTemplateVersionAPI(data, options = {}) {
  return request({
    url: "/channels/templates/default",
    method: "post",
    data,
    ...options,
  });
}

export function deleteTemplateVersionAPI(data, options = {}) {
  return request({
    url: "/channels/templates/delete",
    method: "delete",
    data: {
      ...data,
      is_entire_templates: false,
    },
    ...options,
  });
}

export function updateTemplateAPI(data, options = {}) {
  return request({
    url: "/channels/templates/update",
    method: "post",
    data,
    ...options,
  });
}
export function deleteTemplateAPI(data, options = {}) {
  return request({
    url: "/channels/templates/delete",
    method: "delete",
    data: {
      ...data,
      is_entire_templates: true,
    },
    ...options,
  });
}
/** ------------- templates end -------------- */

/** ---------------- credentials start ------------ */

export function getCredentialChannelsAPI(data, unused_options = {}) {
  return request({
    url: "/channels/types/credentials",
    method: "get",
  });
}

export function getCredentialFullListAPI(data, signal) {
  return request({
    url: "/channels/credentials/full",
    method: "post",
    data,
    signal,
  });
}

export function revealCredentialAPI(data, options = {}) {
  return request({
    url: "/channels/credentials/reveal",
    method: "post",
    data,
    ...options,
  });
}
export function createCredentialAPI(data, options = {}) {
  return request({
    url: "/channels/credentials/create",
    method: "post",
    data,
    ...options,
  });
}

export function updateCredentialAPI(data, options = {}) {
  return request({
    url: "/channels/credentials/update",
    method: "post",
    data,
    ...options,
  });
}

export function deleteCredentialAPI(data, options = {}) {
  return request({
    url: "/channels/credentials/delete",
    method: "delete",
    data,
    ...options,
  });
}

export function getAuthenticationURL(data, options = {}) {
  return request({
    url: "/channels/credentials/authenticate",
    method: "post",
    data,
    ...options,
  });
}

export function getAuthenticationCallback(data, options = {}) {
  return request({
    url: "/channels/credentials/authenticate/callback",
    method: "post",
    data,
    ...options,
  });
}
/** ---------------- credentials end ------------ */

/** workflow start */
export function getNodeChannelsAPI() {
  return request({
    url: "/channels/types",
    method: "get",
  });
}

/** workflow end */

/*-----------------channels--------------------*/
export function getSeqChannelTypes() {
  return request({
    url: "/channels/types",
    method: "get",
  });
}
/*-----------------channel-template--------------------*/
export function getSeqChannelTemplateList(data) {
  return request({
    url: "/channels/templates",
    method: "post",
    data,
  });
}

export function lookupSeqChannelTemplate(data) {
  return request({
    url: "/channels/templates/lookup",
    method: "post",
    data,
  });
}
export function createSeqChannelTemplate(data) {
  return request({
    url: "/channels/templates/create",
    method: "post",
    data,
  });
}
export function createSeqTemplateVersion(data) {
  return request({
    url: "/channels/templates/create_version",
    method: "post",
    data,
  });
}

/*-----------------channel-template-group----------------------*/
export function getSeqChannelTemplateGroupList(data) {
  return request({
    url: "/channels/templates/groups",
    method: "post",
    data,
  });
}
export function createSeqChannelTemplateGroup(data) {
  return request({
    url: "/channels/templates/groups/create",
    method: "post",
    data,
  });
}
export function updateSeqChannelTemplateGroup(data) {
  return request({
    url: "/channels/templates/groups/update",
    method: "post",
    data,
  });
}
export function deleteSeqChannelTemplateGroup(data) {
  return request({
    url: "/channels/templates/groups/delete",
    method: "delete",
    data,
  });
}
export function addTemplateToGroup(data) {
  return request({
    url: "/channels/templates/relationship/create",
    method: "post",
    data,
  });
}
export function updateTemplateGroup(data) {
  return request({
    url: "/channels/templates/relationship/update",
    method: "post",
    data,
  });
}
export function removeTemplateFromGroup(data) {
  return request({
    url: "/channels/templates/relationship/delete",
    method: "delete",
    data,
  });
}

/*-----------------schedule--------------------*/
export function getSeqScheduleList(data, signal) {
  return request({
    url: "/schedules",
    method: "post",
    data,
    signal,
  });
}
export function createSeqSchedule(data, option = {}) {
  return request({
    url: "/schedules/create",
    method: "post",
    data,
    ...option,
  });
}
export function updateSeqSchedule(data) {
  return request({
    url: "/schedules/update",
    method: "post",
    data,
  });
}
export function deleteSeqSchedule(data) {
  return request({
    url: "/schedules/delete",
    method: "delete",
    data,
  });
}
export function setDefaultSchedule(data) {
  return request({
    url: "/schedules/default",
    method: "post",
    data,
  });
}

/*-----------------upload--------------------*/
export function uploadSeqFile(data) {
  return request({
    url: "/attachments/batch_upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export function getImage(profileId, hash) {
  return request({
    url: `/attachments/hash/${profileId}/${hash}`,
    method: "get",
    responseType: "blob",
  });
}
export function downloadFile(data) {
  return request({
    url: "/attachments/download",
    method: "post",
    data,
    responseType: "blob",
  });
}

/*------------------account-email--------------------*/
export function getSeqAccountEmailList(data) {
  return request({
    url: "/channels/email_accounts",
    method: "post",
    data,
  });
}
export function getEmailAuth(data) {
  return request({
    url: "/channels/email_accounts/auth_url",
    method: "post",
    data,
  });
}
export function updateEmailAccount(data) {
  return request({
    url: "/channels/email_accounts/update",
    method: "post",
    data,
  });
}
export function setDefaultEmail(data) {
  return request({
    url: "/channels/email_accounts/default",
    method: "post",
    data,
  });
}
export function unlinkAccount(data) {
  return request({
    url: "/channels/email_accounts/unlink",
    method: "post",
    data,
  });
}
/*------------------account-LinkedIn--------------------*/
export function getSeqAccountLinkedinList(data) {
  return request({
    url: "/channels/linkedin_accounts",
    method: "post",
    data,
  });
}
/*------------------step--------------------*/
export function getSeqStepList(data) {
  return request({
    url: "/sequences/steps",
    method: "post",
    data,
  });
}

export function createSeqStep(data, options = {}) {
  return request({
    url: "/sequences/steps/create",
    method: "post",
    data,
    ...options,
  });
}

export function createStepVersion(data) {
  return request({
    url: "/sequences/steps/create_version",
    method: "post",
    data,
  });
}
export function updateSeqStep(data, options = {}) {
  return request({
    url: "/sequences/steps/update",
    method: "post",
    data,
    ...options,
  });
}

export function deleteSeqStep(data) {
  return request({
    url: "/sequences/steps/delete",
    method: "delete",
    data,
  });
}
export function setDefaultStep(data) {
  return request({
    url: "/sequences/steps/default",
    method: "post",
    data,
  });
}
/*------------------contact--------------------*/
export function getSeqContactList(data) {
  return request({
    url: "/sequences/contacts/",
    method: "post",
    data,
  });
}
export function getContactMetadata(data) {
  return request({
    url: "/sequences/contacts/metadata",
    method: "post",
    data,
  });
}
export function getContactStatus(unused_data) {
  return request({
    url: "/sequences/targets/status/types",
    method: "get",
  });
}
export function creatSeqContactManually(data) {
  return request({
    url: "/sequences/contacts/create",
    method: "post",
    data,
  });
}
export function analyzeSeqContact(data) {
  return request({
    url: "/sequences/contacts/analyze",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export function importSeqContact(data) {
  return request({
    url: "/sequences/contacts/import_files",
    method: "post",
    data,
  });
}
export function updateSeqContact(data) {
  return request({
    url: "/sequences/contacts/update",
    method: "post",
    data,
  });
}
export function deleteSeqContact(data) {
  return request({
    url: "/sequences/contacts/delete",
    method: "delete",
    data,
  });
}
export function addContactToMy(data) {
  return request({
    url: "/sequences/contacts/import_lists",
    method: "post",
    data,
  });
}

export function updateContactStatus(data) {
  return request({
    url: "/sequences/contacts/update/status",
    method: "post",
    data,
  });
}
export function exportContacts(data) {
  return request({
    url: "/sequences/contacts/export",
    method: "post",
    data,
  });
}
export function exportContactsFull(data) {
  return request({
    url: "/sequences/contacts/export/full",
    method: "post",
    data,
  });
}
export function getSeqContactAllIds(data) {
  return request({
    url: "/sequences/contacts/select",
    method: "post",
    data,
  });
}

/*------------------send Email--------------------*/
export function sendEmail(data) {
  return request({
    url: "/channels/email_accounts/send_test_email",
    method: "post",
    data,
  });
}

/*------------------inbox--------------------*/

export function getSeqInboxList(data, signal) {
  return request({
    url: "/sequences/inboxes",
    method: "post",
    data,
    signal,
  });
}
export function getSeqInboxMeta(data) {
  return request({
    url: "/sequences/inboxes/metadata",
    method: "post",
    data,
  });
}
export function lookupSeqInbox(data) {
  return request({
    url: "/sequences/inboxes/lookup",
    method: "post",
    data,
  });
}
export function emailToSeqContact(data) {
  return request({
    url: "/sequences/inboxes/channels/email/send",
    method: "post",
    data,
  });
}

export function getMessageStatus(unused_data) {
  return request({
    url: "/channels/messages/status",
    method: "get",
  });
}
export function deleteInbox(data) {
  return request({
    url: "/sequences/inboxes/delete",
    method: "delete",
    data,
  });
}
export function exportSeqInboxFull(data) {
  return request({
    url: "/sequences/inboxes/export/full",
    method: "post",
    data,
  });
}
export function exportSeqInboxPartial(data) {
  return request({
    url: "/sequences/inboxes/export",
    method: "post",
    data,
  });
}
export function getSeqInboxAllIds(data) {
  return request({
    url: "/sequences/inboxes/select",
    method: "post",
    data,
  });
}

/*------------------inbox category-------------------*/

export function getSeqInboxCategoryList(data) {
  return request({
    url: "/sequences/inboxes/categories",
    method: "post",
    data,
  });
}
export function createSeqInboxCategory(data) {
  return request({
    url: "/sequences/inboxes/categories/create",
    method: "post",
    data,
  });
}
export function addSeqToCategory(data) {
  return request({
    url: "/sequences/inboxes/categories/add",
    method: "post",
    data,
  });
}
export function editSeqInboxCategory(data) {
  return request({
    url: "/sequences/inboxes/categories/edit",
    method: "post",
    data,
  });
}
export function removeSeqFromCategory(data) {
  return request({
    url: "/sequences/inboxes/categories/delete",
    method: "post",
    data,
  });
}
export function updateSeqInboxCategory(data) {
  return request({
    url: "/sequences/inboxes/categories/update",
    method: "post",
    data,
  });
}
export function deleteSeqInboxCategory(data) {
  return request({
    url: "/sequences/inboxes/categories/delete",
    method: "delete",
    data,
  });
}

export function queryTargetsList(data, signal) {
  return request({
    url: "/sequences/targets",
    method: "post",
    data,
    signal,
  });
}

export function analazeTargetsCsv(data, option = {}) {
  return request({
    url: "/sequences/targets/analyze",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    ...option,
  });
}

export function importTargetsCsv(data, option = {}) {
  return request({
    url: "/sequences/targets/import",
    method: "post",
    data,
    ...option,
  });
}

export function addTargets(data, option = {}) {
  return request({
    url: "/sequences/targets/add",
    method: "post",
    data,
    ...option,
  });
}

export function deleteSequencesTarget(data) {
  return request({
    url: "/sequences/targets/delete",
    method: "delete",
    data,
  });
}

export function getSelectedTargets(data, option = {}) {
  return request({
    url: "/sequences/targets/select",
    method: "post",
    data,
    ...option,
  });
}

export function createManualTarget(data, option = {}) {
  return request({
    url: "/sequences/targets/create",
    method: "post",
    data,
    ...option,
  });
}
export function updateTargets(data, option = {}) {
  return request({
    url: "/sequences/targets/update",
    method: "post",
    data,
    ...option,
  });
}

export function getSequenceLogs(data, signal) {
  return request({
    url: "/sequences/statistics/logs",
    method: "post",
    data,
    signal,
  });
}

export function getSelectedLogs(data, option = {}) {
  return request({
    url: "/sequences/statistics/logs/select",
    method: "post",
    data,
    ...option,
  });
}

export function exportLogs(data, option = {}) {
  return request({
    url: "/sequences/statistics/logs/export",
    method: "post",
    data,
    ...option,
  });
}

export function updateTargetStatus(data) {
  return request({
    url: "/sequences/targets/update/status",
    method: "post",
    data,
  });
}

export function exportTargets(data) {
  return request({
    url: "/sequences/targets/export",
    method: "post",
    data,
  });
}

export function runWorkflowNode(data, option = {}) {
  return request({
    url: "/sequences/process/try",
    method: "post",
    data,
    ...option,
  });
}

export function getSequenceStepsStats(data, option = {}) {
  return request({
    url: "/sequences/statistics/steps",
    method: "post",
    data,
    ...option,
  });
}

export function duplicateSequence(data, option = {}) {
  return request({
    url: "/sequences/duplicate",
    method: "post",
    data,
    ...option,
  });
}

export function querySequenceReportActionsAnalytics(data, option = {}) {
  return request({
    url: "/sequences/statistics/steps/actions",
    method: "post",
    data,
    ...option,
  });
}

export function querySequenceReportInteractions(data, option = {}) {
  return request({
    url: "/sequences/statistics/steps/actions/interactions",
    method: "post",
    data,
    ...option,
  });
}

export function getSequenceReportInteractionsSelected(data, option = {}) {
  return request({
    url: "/sequences/statistics/steps/actions/interactions/select",
    method: "post",
    data,
    ...option,
  });
}

export function exportSequenceReportInteractions(data, option = {}) {
  return request({
    url: "/sequences/statistics/steps/actions/interactions/export",
    method: "post",
    data,
    ...option,
  });
}

export const getSequenceTemplateList = (data, options = {}) => {
  return request({
    url: "/sequences/templates/",
    method: "post",
    data,
    ...options,
  });
};

export const createSequenceFromTemplate = (data, options = {}) => {
  return request({
    url: "/sequences/templates/wizard",
    method: "post",
    data,
    ...options,
  });
};

export const getSendingDomains = (data, options = {}) => {
  return request({
    url: "/channels/sending_domains/list",
    method: "post",
    data,
    ...options,
  });
};

export const addSendingDomain = (data, options = {}) => {
  return request({
    url: "/channels/sending_domains",
    method: "post",
    data,
    ...options,
  });
};

export const verifySendingDomain = (data, options = {}) => {
  return request({
    url: "/channels/sending_domains/verify",
    method: "post",
    data,
    ...options,
  });
};
